import React, { PureComponent } from 'react';
import Modal from 'react-modal';
import Button from '../Button';
import styles from './DeleteModel.module.css';
import PropTypes from 'prop-types';

const customStyles = {
  content: {
    top: '35%',
    left: '50%',
    width: '500px',
    right: 'auto',
    bottom: 'auto',
    border: '1px solid grey',
    padding: '20px',
    borderRadius: 0,
    transform: 'translate(-50%, -50%)',
  },
};

export default class DeleteModel extends PureComponent {
  state = {};

  static contextTypes = {
    router: PropTypes.object,
  };

  deleteModel = async () => {
    const { deleteModel } = this.props;
    const { router } = this.context;
    const id = router.route.location.pathname.split('/')[2];
    await deleteModel(id);
  };

  render() {
    const { open, closeModal, type } = this.props;
    return (
      <Modal isOpen={open} style={customStyles}>
        <div className={styles.content}>
          <div className={styles.closeIcon} onClick={closeModal} />
          <div className={styles.header}>Delete {type} </div>
          <div className={styles.text}>
            {' '}
            Do you want to delete the {type.toLowerCase()} ?
          </div>
          <div className={styles.btnGroup}>
            <Button text="Yes" onClick={this.deleteModel} />
            <Button text="No" style={{ marginLeft: 30 }} onClick={closeModal} />
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DeleteModel/index.js